<template></template>

<script>
import {Inertia} from "@inertiajs/inertia";
import {onUnmounted} from "vue";
import {debug} from "@/helpers";
export default {
  setup(){

    const removeListener = Inertia.on('navigate', (event) => {
      if (typeof ga !== "undefined") {
        debug('Sending GA analytics')
        ga('event', 'page_view', {
          'page_location': event.detail.page.url
        });
      }
    })

    onUnmounted(() => {
      removeListener();
    })
  }
}
</script>
